import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { type SimpleSelectOption } from '@workwave-tidal/core/components'

import { selectUserConfiguration } from '@/features/domain/user'
import { intl } from '@/intl'
import { conversionUtils } from '@/server-data'

import { form } from '../../../formState'
import * as OrderTexts from '../../../intl'
import { Props } from '../typings'

const parseSecondToText = (seconds: number, userConfig: uui.domain.UserConfiguration): string =>
  seconds > 0 ? conversionUtils.convertTime(userConfig)(seconds) : OrderTexts.getNoneText()

export const composeValues = (): SimpleSelectOption<string>[] => [
  {
    value: 'done',
    label: intl.translate({ id: 'orders.stepTrackingDataStatus.done' }),
  },
  {
    value: 'reschedule',
    label: intl.translate({ id: 'orders.stepTrackingDataStatus.reschedule' }),
  },
  {
    value: 'missing',
    label: intl.translate({ id: 'orders.stepTrackingDataStatus.none' }),
  },
]

export function ReportedStatus(props: Props) {
  const values = useMemo(() => composeValues(), [])
  const userConfig = useSelector(selectUserConfiguration)

  const {
    values: { statusSec },
  } = props

  const reportedStatusLabel: string =
    statusSec > 0
      ? OrderTexts.getReportedStatusWithDate(parseSecondToText(statusSec, userConfig))
      : OrderTexts.getReportedStatus()

  return (
    <form.SimpleSelect
      testId="ReportedStatus-root"
      name="status"
      label={reportedStatusLabel}
      options={values}
    />
  )
}
